interface Props {
    children: React.ReactNode
}

export function Subcontainer({ children }: Props) {
    return (
        <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-6 mt-0">
            {children}
        </div>
    )
}